<template>
  <div class="container-fluid" id="content">
    <div class="row justify-content-center mt-5 mb-5">
      <div class="container">
        <div class="accordion arrows col-lg-12 col-md-12 col-sm-12">
          <header class="box">
            <label for="acc-close" class="box-title">{{ $t('faqHeader') }}</label>
          </header>
          <input type="radio" name="accordion" id="cb1" />
          <section class="box">
            <label class="box-title" for="cb1">{{ $t('q1') }}</label>
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              {{ $t('a1') }}
            </div>
          </section>
          <input type="radio" name="accordion" id="cb2" />
          <section class="box">
            <label class="box-title" for="cb2"
              >{{ $t('q2') }}</label
            >
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              {{ $t('a2') }}
            </div>
          </section>
          <input type="radio" name="accordion" id="cb3" />
          <section class="box">
            <label class="box-title" for="cb3">{{ $t('q3') }}</label>
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              {{ $t('a3') }}
            </div>
          </section>

          <input type="radio" name="accordion" id="acc-close" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FaQ",
};
</script>

<style scoped>
.accordion {
  margin: auto;
  width: 100%;
  max-width: 1500px;
}
.accordion input {
  display: none;
}
.box {
  position: relative;
  background: white;
  height: 64px;
  transition: all 0.15s ease-in-out;
}
.box::before {
  content: "";
  position: absolute;
  display: block;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  box-shadow: 0 -1px 0 #e5e5e5, 0 0 2px rgba(0, 0, 0, 0.12),
    0 2px 4px rgba(0, 106, 57, 0.24);
}
header.box {
  background: #077747;
  z-index: 100;
  cursor: initial;
  box-shadow: 0 -1px 0 #e5e5e5, 0 0 2px -2px rgba(0, 0, 0, 0.12),
    0 2px 4px -4px rgba(0, 0, 0, 0.24);
}
header .box-title {
  margin: 0;
  font-weight: normal;
  font-size: 16pt;
  color: white;
  cursor: initial;
  text-align: left;
  padding-left: 10px; /* Add padding to align left */
}
.box-title {
  width: calc(100% - 20px);
  height: 64px;
  line-height: 64px;
  padding: 0 10px; /* Add padding for left alignment */
  display: inline-block;
  cursor: pointer;
  text-align: left; /* Align text to the left */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.box-content {
  width: calc(100% - 20px);
  padding: 20px 10px; /* Adjust padding for left alignment */
  font-size: 11pt;
  color: rgba(0, 0, 0, 0.54);
  display: none;
  text-align: left; /* Align content to the left */
}
.box-close {
  position: absolute;
  height: 64px;
  width: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  display: none;
}
input:checked + .box {
  height: auto;
  margin: 16px 0;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.16), 0 6px 12px rgba(0, 0, 0, 0.32);
}
input:checked + .box .box-title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
}
input:checked + .box .box-content,
input:checked + .box .box-close {
  display: inline-block;
}
.arrows section .box-title {
  padding-left: 44px;
  width: calc(100% - 64px);
}
.arrows section .box-title:before {
  position: absolute;
  display: block;
  content: "\203a";
  font-size: 18pt;
  left: 20px;
  top: -2px;
  transition: transform 0.15s ease-in-out;
  color: rgba(0, 0, 0, 0.54);
}
input:checked + section.box .box-title:before {
  transform: rotate(90deg);
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .accordion {
    width: 90%;
  }
  .box-title {
    font-size: 14pt;
  }
  .box-content {
    font-size: 10pt;
  }
  .box {
    height: 56px;
  }
}
</style>
